import React from 'react';

const shimmer = `
@keyframes shimmer {
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
}
`;

const skeletonStyle = {
  background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
  backgroundSize: '800px 100%',
  animation: 'shimmer 1.5s infinite linear',
  borderRadius: '8px',
};

const PageSkeleton = () => (
  <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
    <style>{shimmer}</style>
    {/* Title skeleton */}
    <div style={{ ...skeletonStyle, width: '200px', height: '32px', marginBottom: '2rem' }} />
    {/* Grid of card skeletons */}
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
      gap: '1.5rem'
    }}>
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} style={{ borderRadius: '12px', overflow: 'hidden' }}>
          <div style={{ ...skeletonStyle, width: '100%', height: '300px', borderRadius: '12px 12px 0 0' }} />
          <div style={{ padding: '1rem' }}>
            <div style={{ ...skeletonStyle, width: '70%', height: '20px', marginBottom: '0.5rem' }} />
            <div style={{ ...skeletonStyle, width: '40%', height: '16px' }} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default PageSkeleton;
